export const BrokenComputerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={124} height={118} fill="none">
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.995}
            d="M99.672 68.957c-1.704-17.032-3.55-39.5-6.086-58.384a.922.922 0 0 0-.41-.582.936.936 0 0 0-.706-.122L9.478 18.002c2.272 22.629 4.3 38.816 6.715 58.606"
        />
        <path
            stroke="#fff"
            strokeLinejoin="round"
            strokeWidth={2.66}
            d="M8.706 78.358C5.866 56.212 4.648 43.77 1.889 16.51a4.702 4.702 0 0 1 .737-3.413 4.768 4.768 0 0 1 2.895-1.982l91.129-9.04a4.32 4.32 0 0 1 2.58.942 4.264 4.264 0 0 1 1.477 2.3c3.733 24.923 4.707 42.821 6.756 63.255L8.706 78.358ZM9.01 78.36h98.899c4.057 12.28 4.341 13.347 8.581 24.641a32.91 32.91 0 0 1 1.765 4.752c.406 2.214.406 5.033-7.1 5.033H13.27c-7.303 0-9.738-.403-9.738-5.436l5.173-28.99"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.995}
            d="m104.42 99.901-4.666-15.904h-82L14.792 99.9h89.628ZM17.308 91.245h84.251M85.492 99.457l-4.666-15.1M33.294 98.633l1.38-14.234M59.849 99.458l-.426-14.656M43.903 113.188l1.42-13.287M79.203 112.987l-2.84-13.086M3.127 107.148c-.405 2.215-.994 7.047 2.597 8.053 2.191.604 3.205.403 8.115.604 33.595.202 67.576 1.007 98.371 0a8.748 8.748 0 0 0 3.206-.402c2.191-.806 4.808-4.429 3.205-7.248M114.198 65.274l4.687-3.382M117.708 72.278h4.849M114.198 79.266l4.687 3.382"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.66}
            d="m55.062 48.26 1.765-.18c.575-8.292.575-16.613 0-24.904a13.509 13.509 0 0 0-4.362-.403c-1.455.2-2.866.635-4.179 1.289a180.14 180.14 0 0 0 5.052 24.38l1.724-.181Z"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.647}
            d="M55.842 60.842c1.73-.174 2.992-1.707 2.817-3.424-.175-1.717-1.72-2.968-3.45-2.795-1.73.173-2.991 1.706-2.816 3.423.174 1.718 1.719 2.969 3.45 2.796Z"
        />
        <path
            fill="#000"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.66}
            d="M56.23 59.803a1.997 1.997 0 0 0 1.79-2.19 2.005 2.005 0 0 0-2.205-1.775 1.997 1.997 0 0 0-1.79 2.188 2.005 2.005 0 0 0 2.206 1.776Z"
        />
    </svg>
);
